import { create } from 'zustand';

interface IdleStoreState {
  idlePromptOpen: boolean;
  setIdlePromptOpen: (value: boolean) => void;

  timeout: number;
  setTimeout: (value: number) => void;
}

export const useIdleStore = create<IdleStoreState>((set) => ({
  idlePromptOpen: false,
  setIdlePromptOpen: (value) => set({ idlePromptOpen: value }),

  timeout: 20 * 60 * 1000, // Default to 20 minutes
  setTimeout: (value) => set({ timeout: value }),
}));
